import { createContext, useContext, useState, useEffect } from 'react';
import { useApolloClient } from '@apollo/client';

import { useCurrentUser } from 'hooks/user/useCurrentUser';

import { IAuthContext, IAuthContextProps } from './AuthContext.types';

const Index = createContext<IAuthContext>({
  isAuthorized: false,
  userLoading: false,
  user: {},
});

export const AuthProvider = ({ children }: IAuthContextProps) => {
  const {
    data: userData,
    loading: userLoading,
    refetch: refetchUser,
  } = useCurrentUser();
  const currentUser = userData?.me;

  const apolloClient = useApolloClient();

  const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

  const updateUser = () => refetchUser();

  const clearApolloStore = async () => {
    await apolloClient.clearStore();
    setIsAuthorized(false);
  };

  useEffect(() => {
    if (!userLoading) {
      if (currentUser) {
        setIsAuthorized(true);
      } else {
        setIsAuthorized(false);
      }
    }
  }, [currentUser, userLoading]);

  useEffect(() => {
    if (ZnanieSDK) {
      // временно решаем так, обновляем юзера в приложении когда получили сигнал о логине пользователя
      ZnanieSDK.on('login', updateUser);
      ZnanieSDK.on('logout', clearApolloStore);
    }

    return () => {
      ZnanieSDK.off('login', updateUser);
      ZnanieSDK.off('logout', clearApolloStore);
    };
  }, []);

  return (
    <Index.Provider
      value={
        {
          isAuthorized,
          userLoading,
          user: currentUser,
        } as IAuthContext
      }
    >
      {children}
    </Index.Provider>
  );
};

export const useAuth = () => useContext(Index);
